export default __webpack_public_path__ + "static/media/fireworks.b1186439.png";